module.exports = __webpack_public_path__ + "img/Programming.85ac352b.svg";